// @flow

import { translations } from '../utils/rewrites/interceptor/translations.js';

const t = translations.en;

const compositePropertyTypeSlug = {
  HOUSE: t.house,
  APPT: t.apartment,
  ROOM: t.room,
  PARK: t.parking,
  PROP: t.plot,
  BUILDING: t.building,
  COMMERCIAL: t.commercial,
  GASTRO: t.hospitality,
  OTHER: t.otherType,
};

// Always use 'en' for tracking listings urls, so in GA4 we will have single url
// per listing instead of up to four (one for each locale: en, fr, de, it).
export const getListingDetailUrl = (
  offerType: string,
  compositePropertyType: string,
  slug: string,
): string => {
  return [
    '',
    'en',
    offerType,
    compositePropertyTypeSlug[compositePropertyType],
    slug,
  ].join('/');
};
